import './index.scss'
import LogoIcon from '../../icons/LogoIcon'

const Loader = () => {
  return (
    <div data-test="loader-icon" className="page-loader">
      <LogoIcon />
    </div>
  )
}

export default Loader
